import { useState } from "react";
import Box from "@mui/material/Box";
import { MdOutlineAccessTime, MdFilterList } from "react-icons/md";
import { FaBreadSlice } from "react-icons/fa";
import { StyledSppedDial, StyledSpeedDialAction } from "./SpeedDial.style";

export default function SpeedDialCM(props) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ transform: "translateZ(0px)" }}>
      <StyledSppedDial
        ariaLabel="SpeedDial tooltip"
        icon={<MdFilterList />}
        open={open}
        direction="left"
        onClick={() => setOpen((state) => !state)}
      >
        <StyledSpeedDialAction
          icon={<MdOutlineAccessTime />}
          tooltipTitle={"تاریخ"}
          onClick={(e) => {
            e.stopPropagation();
            props.filterDate(e);
          }}
          active={props.isDateFiltred ? "yes" : "no"}
        />
        <StyledSpeedDialAction
          icon={<FaBreadSlice />}
          tooltipTitle={"نوع نان"}
          onClick={(e) => {
            e.stopPropagation();
            props.filterBread(e);
          }}
          active={props.isBreadFiltred ? "yes" : "no"}
        />
      </StyledSppedDial>
    </Box>
  );
}
